import axios from 'axios'
import * as types from '../mutation-types'
import { flatten } from '~/helpers/data-structure'
import { isEmpty } from 'lodash'
import Vue from 'vue'

// state
export const state = {
  commonMenu: {},
  productFilterTabs: [],
  routeParameters: null,
  editMode: {
    show: false,
    shopByGalleryEditMode: false
  },
  adminViewMode: {
    show: false
  },
  FiltersParam: {
    brandId: '',
    departmentId: '',
    categoryId: '',
  },
  menuSearchFilterCheck: false,
}

// getters
export const getters = {
  menuSearchFilterCheck: state => state.menuSearchFilterCheck,
  commonMenu: state => state.commonMenu,
    filtersData: state => state.commonMenu.filter_section,
  productFilterTabs: state => state.productFilterTabs,
  getSelectedChildrenProductFilterTabItems: state => {
    return state.productFilterTabs
      ? flatten(state.productFilterTabs)
        .filter(item => !!item.checked)
      : []
  },
  buildFilterData: (state, getters) => {
    const obj = {}

    if (!getters.getSelectedChildrenProductFilterTabItems.length) return obj

    const productFilterTabsState = [...state.productFilterTabs]

    for (const filterTabItem of productFilterTabsState) {
      const selectedChildren = filterTabItem
        .children
        .filter(item => item.checked)

      if (!selectedChildren.length) continue

      obj[filterTabItem.name] = selectedChildren
        .map(item => item.id)
        .join(',')
    }

    return obj
  }
}

// mutation
export const mutations = {
  [types.FETCH_COMMON_MENU] (state, payload) {
    state.commonMenu = payload
  },
  [types.FETCH_PRODUCT_FILTER_TABS_MENU] (state) {
    if (!isEmpty(state.commonMenu)) {
      for (const key in state.commonMenu.filter_section) {
        // Check if the key is "sub_brand" and remove it
        if (key === 'sub_brand') {
          // Commented this line while UI design
          // delete state.commonMenu.filter_section[key];
        } else {
          // Assuming you also want to remove "sub_brand" from the nested arrays
          state.commonMenu.filter_section[key] = state.commonMenu.filter_section[key].filter(item => item.name !== 'sub_brand');
        }
      }
      state.productFilterTabs = Object.keys(state.commonMenu?.filter_section).map((item, index) => ({
        id: index + 1,
        name: item,
        expanded: false,
        checkedCount: 0,
        children: state.commonMenu?.filter_section[item].map(item => ({
          ...item,
          checked: false
        }))
      }))
    }
  },
  [types.SET_SELECTED_CHILDREN_CHECKBOX] (state, { parentIndex, childrenIndex, value }) {
      const currentItem = state.productFilterTabs[parentIndex]
      if (currentItem) {
        currentItem.children[childrenIndex].checked = value
        currentItem.checkedCount = currentItem.children?.filter(item => !!item.checked).length
      }
  },
  [types.SET_PRODUCTS_FILTERS] (state, { brandId, departmentId, categoryId }) {
    state.FiltersParam = { brandId: brandId, departmentId: departmentId, categoryId: categoryId }

    console.log('state filters',state.FiltersParam)
    // const currentItem = state.productFilterTabs[parentIndex]
    // if (currentItem) {
    //   currentItem.children[childrenIndex].checked = value
    //   currentItem.checkedCount = currentItem.children?.filter(item => !!item.checked).length
    // }
},
  [types.FETCH_PRODUCT_DEFAULT_FILTER_TABS_MENU] (state) {
    if (!isEmpty(state.commonMenu)) {
      state.productFilterTabs[1].expanded = true
      const updatedChildren = state.productFilterTabs[1].children.map(item => {
        return { ...item, checked: true }
      })
      Vue.set(state.productFilterTabs, 1, {
        ...state.productFilterTabs[1],
        children: updatedChildren
      })
    }
  },
  [types.SEARCH_FILTER_CHECK] (state, payload) {
    state.menuSearchFilterCheck = payload
  },
  [types.SET_SELECTED_SEARCH_FILTER_CHECKBOX] (state, {payload, filterName}) {

    // console.log('filter name',filterName)
    setTimeout(()=> {
      if (Array.isArray(filterName.tab)) {
          // console.log("list")
          filterName.tab.forEach(singleFilterName => {
            if (payload[singleFilterName]) {
              const filterList = payload[singleFilterName].split(',');
              const filter = state.productFilterTabs.find(item => item.name === singleFilterName);
              if (filter) {
                filter.children = filter.children.map((item, index) => {
                  return {
                    ...item,
                    checked: filterList.includes(String(index + 1)) ? true : false,
                  };
                });
              }
            }
            // updateFilterChildren(state, payload, singleFilterName);
          });
      }else if(typeof filterName.tab === 'string'){
        if (payload[filterName]) {
          const filterList = payload[filterName].split(',');
          const filter = state.productFilterTabs.find(item => item.name === filterName);

          if (filter) {
            filter.children = filter.children.map((item, index) => {
              return {
                ...item,
                checked: filterList.includes(String(index + 1)) ? true : false,
              };
            });
          }
        }
      }

      if (payload.brand) {
        const brandList = payload.brand.split(',');
        const filterBrand = state.productFilterTabs.find(item => item.name === 'brand');

        if (filterBrand) {
          filterBrand.children = filterBrand.children.map((item, index) => {
            return {
              ...item,
              checked: brandList.includes(String(index + 1)) ? true : false,
            };
          });
        }
      }else if (payload.department) {
        const brandList = payload.department.split(',');
        const filterBrand = state.productFilterTabs.find(item => item.name === 'department');

        if (filterBrand) {
          filterBrand.children = filterBrand.children.map((item, index) => {
            return {
              ...item,
              checked: brandList.includes(String(index + 1)) ? true : false,
            };
          });
        }
      }else if (payload.category) {
        const brandList = payload.category.split(',');
        const filterBrand = state.productFilterTabs.find(item => item.name === 'category');

        if (filterBrand) {
          filterBrand.children = filterBrand.children.map((item, index) => {
            return {
              ...item,
              checked: brandList.includes(String(index + 1)) ? true : false,
            };
          });
        }
      }
    }, 600)
  },
  [types.SET_SELECTED_CHECKBOX] (state, { parentIndex}) {
      setTimeout(() => {
        if (!isEmpty(state.commonMenu)) {
          if(parentIndex.tab === 'brand'){
            const tab = state.productFilterTabs.filter(item => item.name == parentIndex.tab);
            if(tab.length > 0) {
              tab[0].expanded = true;
              tab[0].children[parentIndex.id-1].checked = true;
          }
        }
        if(parentIndex.tab === 'sub_brand'){
          state.productFilterTabs[parentIndex.subBrandId].children.forEach(item => {
            item.checked = false
          })
          const brandTab = state.productFilterTabs.filter(item => item.name == 'brand');
            brandTab[0].expanded = true;
            brandTab[0].children[parentIndex.brandId-1].checked = true;
          const SubBrandTab = state.productFilterTabs.filter(item => item.name == 'sub_brand');
          SubBrandTab[0].expanded = true;
          const childSubBrandArray = SubBrandTab[0].children.filter(item => item.id === parentIndex.subBrandId);
          if (childSubBrandArray.length > 0) {
            const childSubBrand = childSubBrandArray[0];
            childSubBrand.checked = true;
          }
        }
          if(parentIndex.tab === 'department'){
            state.productFilterTabs[parentIndex.id].children.forEach(item => {
              item.checked = false
            })
            const brandTab = state.productFilterTabs.filter(item => item.name == 'brand');
            brandTab[0].expanded = true;
            brandTab[0].children[parentIndex.brandId-1].checked = true;
            const tabDepartment = state.productFilterTabs.filter(item => item.name == parentIndex.tab);
            if(tabDepartment.length > 0) {
              tabDepartment[0].expanded = true;
              tabDepartment[0].children[parentIndex.id-1].checked = true;
          }
          }
          if(parentIndex.tab === 'category'){
            const brandTab = state.productFilterTabs.filter(item => item.name == 'brand');
            brandTab[0].expanded = true;
            brandTab[0].children[parentIndex.brandId-1].checked = true;
            const tabDepartment = state.productFilterTabs.filter(item => item.name == 'department');
            tabDepartment[0].expanded = true;
            tabDepartment[0].children[parentIndex.departmentId-1].checked = true;
            const tabCategory = state.productFilterTabs.filter(item => item.name == parentIndex.tab);
            if(tabCategory.length > 0) {
              tabCategory[0].expanded = true;
              tabCategory[0].children[parentIndex.id-1].checked = true;
          }
          }
          }
      },300)
  },
  [types.SET_EXPAND_SIDE_FILTER] (state, { payload}) {
    setTimeout(() => {
      // console.log('tabbbbss',payload)
      if (Array.isArray(payload.tab)) {
        state.productFilterTabs.forEach(tab => {
          tab.expanded = false;
        });
        payload.tab.forEach(tabItem => {
          const tabToExpand = state.productFilterTabs.find(stateItem => stateItem.name === tabItem);
          tabToExpand.expanded = true;
        // state.productFilterTabs.forEach(item => {
        //   item.children.forEach(childItem => {
        //     if (item.checked) {
        //       if (tabToExpand && !tabToExpand.expanded) {
        //         console.log(childItem, state.productFilterTabs);
        //       }
        //     }
        //   });
        // });
      })
      }
      // else if(typeof payload.tab === 'string'){
      //   console.log("stringngngngngngnng")
      //   if (!isEmpty(state.commonMenu)) {
      //     state.productFilterTabs.forEach(item => {
      //       item.expanded = false;
      //     });
      //     const tabToExpand = state.productFilterTabs.find(item => item.name === payload.tab);
      //     // console.log(tabToExpand);
      //     if (tabToExpand) {
      //       tabToExpand.expanded = true;
      //     }
      //   }
      // }
      else{
        console.log('tab is not defined');
      }
  },600)
  },
  [types.FILTER_CHECK_BOX] (state, { checkboxObj }) {
    // console.log('setting selected', checkboxObj)
    // if(checkboxObj.tab === 'brand'){
    //   console.log('brand',state.commonMenu.filter_section)
    //   state.commonMenu.filter_section[checkboxObj.tab].forEach(a => {
    //     a.value = false
    //   })
    //   let childrenObject = state.productFilterTabs[checkboxObj.tabId]
    //   // console.log('XXXX', childrenObject)
    //   // let checked =  childrenObject.children[checkboxObj.childId]
    //     // console.log('checked', checked)
    // }if(checkboxObj.tab === 'department'){
    //   console.log('department')
    // }if (checkboxObj.tab === 'category'){
    //   console.log('category')
    // }
  },
  [types.UNSELECT_ALL_CHILDREN_CHECKBOX] (state, parentIndexObj = null) {
    // console.log('unselect')
    if (!parentIndexObj.parentIndex) {
      state.productFilterTabs.forEach(a => {
        a.children.forEach(item => {
          item.checked = false
        })
      })
      return
    }
    state.productFilterTabs[parentIndexObj.parentIndex].children.forEach(item => {
      item.checked = false
    })
  },
  [types.FOLD_ALL_EXPANDED_ITEMS] (state) {
    state.productFilterTabs.forEach(item => {
      item.expanded = false
    })
  },
  [types.SET_MENUS_EDIT_MODE] (state, payload) {
    state.editMode = {
      ...state.editMode,
      ...payload
    }
  },
  [types.SET_MENUS_ADMIN_VIEW] (state, payload) {
    state.adminViewMode = {
      ...state.adminViewMode,
      ...payload
    }
  },
  [types.SET_ROUTE_PARAMS_VIEW] (state, payload) {

    // console.log('payload', payload)
    state.routeParameters = {
      ...state.routeParameters,
      ...payload
    }
  }
}

// actions
export const actions = {
  async fetchCommonMenu ({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/dashboard/load-common-menu')

      commit(types.FETCH_COMMON_MENU, data)
      commit(types.FETCH_PRODUCT_FILTER_TABS_MENU)
    } catch (e) {
      console.log(e)
    }
  },
  fetchProductFilterTabMenu ({ commit }) {
    commit(types.FETCH_PRODUCT_FILTER_TABS_MENU)
  },
  fatchProductDefualtFilterTabMenu ({ commit }) {
    commit(types.FETCH_PRODUCT_DEFAULT_FILTER_TABS_MENU)
  },
  setSelectedChildrenCheckBox ({ commit }, { parentIndex, childrenIndex, value, source, parentName }) {
    commit(types.SET_SELECTED_CHILDREN_CHECKBOX, { parentIndex, childrenIndex, value, source, parentName })
  },
  setProductsFilters ({ commit }, { brandId, departmentId, categoryId }) {
    commit(types.SET_PRODUCTS_FILTERS, { brandId, departmentId, categoryId })
  },
  setSelectedCheckBox ({ commit }, { parentIndex }) {
    commit(types.SET_SELECTED_CHECKBOX, { parentIndex })
  },
  setSelectedSearchFilterCheckBox ({ commit }, { payload , filterName}) {
    commit(types.SET_SELECTED_SEARCH_FILTER_CHECKBOX, { payload, filterName })
  },
  setExpandSideFilter ({ commit }, { payload }) {
    commit(types.SET_EXPAND_SIDE_FILTER, { payload })
  },
  filterCheckBox ({ commit }, {checkboxObj}) {
    commit(types.FILTER_CHECK_BOX, { checkboxObj })
  },
  unSelectAllChildrenCheckBox ({ commit }, { parentIndex }) {
    commit(types.UNSELECT_ALL_CHILDREN_CHECKBOX, { parentIndex })
  },
  setRouteParams ({ commit }, { routeParams }) {
    commit(types.SET_ROUTE_PARAMS_VIEW, { routeParams })
  },
  async searchFilterCheck ({ commit }, payload) {
    commit(types.SEARCH_FILTER_CHECK, payload)
  },
  setMenusAdminView ({ commit }, payload) {
    commit(types.SET_MENUS_ADMIN_VIEW, payload)
  },
}
